/** Chuỗi nút "Tải dữ liệu khách" ở Cấu hình → Thông tin tiệm (kế hoạch 10/2026, 5.5, ADR-094). */
export const TD = {
  tieuDe: 'Dữ liệu khách của tiệm',
  goiY: 'Tệp có tên, số điện thoại, số dư ví, gói còn buổi. Giữ kín tệp này.',
  /** Money-auditor 11/10 VỪA 1: Σ ví trong tệp có thể nhỏ hơn "Nợ ví" ở báo cáo — nói rõ vì sao. */
  khongGom:
    'Khách đã xoá dữ liệu không nằm trong tệp. Số dư của họ (nếu còn) vẫn tính trong báo cáo Gói và ví.',
  nut: 'Tải dữ liệu khách',
  dang: 'Đang tải…',
  xong: 'Đã tải tệp khách về máy',
} as const
